let _this;

class PubSub {
  constructor() {
    this.events = {};
    this.props = this.events.hasOwnProperty;

    if (!_this) _this = this;

    return _this;
  }

  subscribe(event, listener) {
    if (!this.props.call(this.events, event)) this.events[event] = [];

    const index = this.events[event].push(listener) - 1;

    return {
      remove: () => {
        delete this.events[event][index];
      },
    };
  }

  publish(event, info) {
    if (!this.props.call(this.events, event)) return;

    this.events[event].forEach((item) => {
      item(info !== undefined ? info : {});
    });
  }
}

export default new PubSub();



// WEBPACK FOOTER //
// ./src/util/pubSub.js